module.exports = __webpack_public_path__ + "static/media/icon-intro.e1f5998b.svg";